module.exports = __webpack_public_path__ + "img/map.1fdd3fca.png";